import { addDays, addYears, max, startOfDay } from 'date-fns';
import compact from 'lodash/compact';
export function getPriceIncreaseDateRange(now, effectiveDate) {
  const today = startOfDay(now);
  return {
    minDate: max(compact([addDays(today, 1), effectiveDate && startOfDay(effectiveDate)])),
    maxDate: addYears(today, 3)
  };
}